<template>
    <div class="dashboard-grid-page">
        <NavBarPP>
            <!-- <template v-slot:first-items>

            </template> -->

            <template v-slot:items-link-logged>
                <li :class="'nav-item'">
                    <b-nav-item-dropdown text="Sobre a Plataforma">
                        <b-dropdown-item router-link :to="{ name: 'HomePage' }">
                            Página inicial
                        </b-dropdown-item>
                        <b-dropdown-item router-link to="/quem-somos">Quem somos</b-dropdown-item>
                        <b-dropdown-item router-link to="/como-surgimos">Como surgimos</b-dropdown-item>
                        <b-dropdown-item router-link to="/para-quem-e">Para quem é</b-dropdown-item>
                        <b-dropdown-item :to="{ name: 'BenefitsPage' }">Benefícios</b-dropdown-item>
                    </b-nav-item-dropdown>
                </li>
                <li :class="'nav-item'" @click="opportunityPanelBtnClick">
                    <router-link class="nav-link" to="/plataforma">Painel de Oportunidades</router-link>
                </li>

                <li :class="'nav-item'" @click="connectionsBtnClick">
                    <router-link class="nav-link" :to="{ name: 'ConnectionsPage' }">Conexões</router-link>
                </li>

                <li :class="'nav-item'">
                    <router-link to="#" class="nav-link" v-b-toggle.sidebar-backdrop @click="openSidebar()"
                        >Convites</router-link
                    >
                </li>

                <li :class="'nav-item'">
                    <router-link class="nav-link" :to="{ name: 'MessagesPage' }">Mensagens</router-link>
                </li>
            </template>

            <template v-slot:right-buttons-logged>
                <span class="navbar-text">
                    <li :class="'nav-item'">
                        <button class="btn btn-default">
                            <i class="far fa-bell"></i>
                        </button>
                    </li>

                    <li :class="'nav-item profile-options'">
                        <b-nav-item-dropdown :text="usuario.name">
                            <b-dropdown-item router-link :to="{ name: 'RegisterGridPage' }" v-if="getAllowRegisterBtn">
                                <b-icon icon="pencil"></b-icon>
                                Continuar Cadastro
                            </b-dropdown-item>
                            <b-dropdown-item router-link :to="{ name: 'MyProfilePage' }">
                                <b-icon icon="person"></b-icon>
                                Meu Perfil
                            </b-dropdown-item>
                            <b-dropdown-item router-link v-b-toggle.sidebar-update-pwd @click="openSidebarUpdatePwd()">
                                <b-icon icon="unlock"></b-icon>
                                Alterar Senha
                            </b-dropdown-item>
                            <b-dropdown-item @click="logout()">
                                <b-icon icon="box-arrow-right"></b-icon>
                                Sair
                            </b-dropdown-item>
                        </b-nav-item-dropdown>
                    </li>
                </span>
            </template>
        </NavBarPP>

        <div class="dashboard-grid-page-body">
            <router-view></router-view>
        </div>

        <FooterPP />

        <b-sidebar id="sidebar-backdrop" title="Enviar convite" backdrop shadow right>
            <div>
                <div>
                    Ajude a Plataforma Potências Periféricas (PPP) a conectar mais e mais pessoas e iniciativas.
                    Preencha os campos abaixo e convide seus parceiros e amigos para participarem da plataforma.
                    <br /><br />Quanto maior a sua rede, melhor!
                </div>

                <b-form @submit.stop.prevent="onSidebarSubmit" novalidate>
                    <b-form-group label="Nome" label-for="nome">
                        <b-form-input
                            id="nome"
                            name="nome"
                            v-model="$v.sidebarForm.nome.$model"
                            type="text"
                            placeholder="Digite nome"
                            :state="validateStateSidebar('nome')"
                        ></b-form-input>

                        <b-form-invalid-feedback :state="validateStateSidebar('nome')">
                            Campo obrigatório
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group label="E-mail" label-for="email">
                        <b-form-input
                            id="email"
                            name="email"
                            v-model="$v.sidebarForm.email.$model"
                            type="text"
                            placeholder="Digite e-mail"
                            :state="validateStateSidebar('email')"
                        ></b-form-input>

                        <b-form-invalid-feedback :state="validateStateSidebar('email')">
                            <div v-if="!$v.sidebarForm.email.required">Campo obrigatório</div>
                            <div v-if="!$v.sidebarForm.email.email">Escreva um e-mail válido</div>
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-button
                        type="submit"
                        :variant="!getIsDarkTheme ? 'dark' : 'primary'"
                        class="radius-6 submit"
                        v-b-toggle.sidebar-backdrop
                    >
                        Enviar convite
                    </b-button>
                </b-form>
            </div>
        </b-sidebar>

        <b-modal
            ref="warning-modal-ref"
            :hide-header="true"
            :hide-footer="true"
            body-class="warning-modal"
            :modal-class="getIsDarkTheme ? 'dark-theme' : ''"
            :no-close-on-backdrop="!errorModal"
        >
            <div class="content">
                <SuccessMsgModal :msg="message" v-if="!errorModal" />

                <DangerMsgModal :msg="message" v-if="errorModal" />
            </div>

            <div class="footer-buttons">
                <b-button variant="danger" @click="hideModal('warning-modal-ref')">Fechar</b-button>
            </div>
        </b-modal>

        <b-modal
            ref="success-modal-ref"
            :hide-header="true"
            :hide-footer="true"
            body-class="warning-modal"
            :modal-class="getIsDarkTheme ? 'dark-theme' : ''"
            :no-close-on-backdrop="true"
        >
            <div class="content">
                <SuccessMsgModal :msg="message" />
            </div>

            <div class="footer-buttons">
                <b-button variant="primary" @click="hideModal('success-modal-ref')">Entendi</b-button>
            </div>
        </b-modal>

        <b-sidebar id="sidebar-update-pwd" :title="'Alterar senha'" backdrop shadow right>
            <div>
                <b-form @submit.stop.prevent="updatePwdSubmit" novalidate>
                    <b-form-group label="Senha atual" label-for="currentPassword" class="password-field">
                        <b-input-group>
                            <b-form-input
                                id="currentPassword"
                                v-model="$v.updatePwdForm.currentPassword.$model"
                                :type="showCurrentPassword ? 'text' : 'password'"
                                placeholder="Digite senha atual"
                                :state="validateStateUpdatePwd('currentPassword')"
                            >
                            </b-form-input>
                            <b-input-group-append class="btn-eye-password">
                                <b-button class="btn" @click="showCurrentPassword = !showCurrentPassword">
                                    <i :class="`fas fa-${showCurrentPassword ? 'eye' : 'eye-slash'}`"></i>
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>

                        <b-form-invalid-feedback :state="validateStateUpdatePwd('currentPassword')">
                            Campo obrigatório
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group label="Nova senha" label-for="password" class="password-field">
                        <b-input-group>
                            <b-form-input
                                id="password"
                                v-model="$v.updatePwdForm.password.$model"
                                :type="showPassword ? 'text' : 'password'"
                                placeholder="Digite uma nova senha"
                                :state="validateStateUpdatePwd('password')"
                            >
                            </b-form-input>
                            <b-input-group-append class="btn-eye-password">
                                <b-button class="btn" @click="showPassword = !showPassword">
                                    <i :class="`fas fa-${showPassword ? 'eye' : 'eye-slash'}`"></i>
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>

                        <b-form-invalid-feedback :state="validateStateUpdatePwd('password')">
                            <div v-if="!$v.updatePwdForm.password.required">
                                Campo obrigatório
                            </div>

                            <div v-if="!$v.updatePwdForm.password.minLength">
                                Deve conter no mínimo 8 caracteres
                            </div>

                            <div v-if="!$v.updatePwdForm.password.containsUppercase">
                                Deve conter no mínimo 1 letra maiúscula
                            </div>

                            <div v-if="!$v.updatePwdForm.password.containsNumber">
                                Deve conter no mínimo 1 número
                            </div>
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group label="Confirmar senha" label-for="confirmPassword" class="password-field">
                        <b-input-group>
                            <b-form-input
                                id="confirm-password"
                                v-model="$v.updatePwdForm.confirmPassword.$model"
                                :type="showConfirmPassword ? 'text' : 'password'"
                                placeholder="Digite novamente sua senha"
                                :state="validateStateUpdatePwd('confirmPassword')"
                            >
                            </b-form-input>
                            <b-input-group-append class="btn-eye-password">
                                <b-button class="btn" @click="showConfirmPassword = !showConfirmPassword">
                                    <i :class="`fas fa-${showConfirmPassword ? 'eye' : 'eye-slash'}`"></i>
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>

                        <b-form-invalid-feedback :state="validateStateUpdatePwd('confirmPassword')">
                            <div v-if="!$v.updatePwdForm.confirmPassword.required">
                                Campo obrigatório
                            </div>
                            <div
                                v-if="!$v.updatePwdForm.confirmPassword.sameAsPassword && updatePwdForm.confirmPassword"
                            >
                                Senhas devem ser iguais
                            </div>
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-button type="submit" :variant="!getIsDarkTheme ? 'dark' : 'primary'" class="radius-6 submit">
                        Salvar
                    </b-button>
                </b-form>
            </div>
        </b-sidebar>

        <DangerModalPP ref="warningModal" :message="message" />
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { required, email, sameAs, minLength } from 'vuelidate/lib/validators'
import NavBarPP from '@/ui/navbar-pp/NavBarPP'
import FooterPP from '@/ui/footer-pp/FooterPP'
import SuccessMsgModal from '@/ui/modal/success-msg-modal/SuccessMsgModal'
import DangerMsgModal from '@/ui/modal/danger-msg-modal/DangerMsgModal'
import DangerModalPP from '@/ui/modal/danger-modal-pp/DangerModalPP'
import { AuthenticationApi } from './../../../api/authentication'
import { PlatformApi } from './../../../api/platform'

const platformApi = new PlatformApi()
const authenticationApi = new AuthenticationApi()

export default {
    components: { NavBarPP, FooterPP, SuccessMsgModal, DangerMsgModal, DangerModalPP },
    data() {
        return {
            usuario: null,
            message: null,
            errorModal: false,
            showCurrentPassword: false,
            showPassword: false,
            showConfirmPassword: false,
            sidebarForm: {
                nome: null,
                email: null
            },
            updatePwdForm: {
                currentPassword: null,
                password: null,
                confirmPassword: null
            }
        }
    },
    validations: {
        sidebarForm: {
            nome: { required },
            email: { required, email }
        },
        updatePwdForm: {
            currentPassword: { required },
            password: {
                required,
                minLength: minLength(8),
                containsUppercase: function(value) {
                    return /[A-Z]/.test(value)
                },
                containsNumber: function(value) {
                    return /[0-9]/.test(value)
                }
            },
            confirmPassword: {
                required,
                sameAsPassword: sameAs('password')
            }
        }
    },
    computed: {
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        },
        getAllowRegisterBtn() {
            return this.$store.state.allowRegisterBtn
        }
    },
    methods: {
        ...mapActions(['setIsLoading', 'changeIsLogged', 'setAllowRegisterBtn', 'setAllowExportBtn']),
        fetch() {
            this.usuario = JSON.parse(localStorage.getItem('usuario'))
            this.setIsLoading(true)

            platformApi
                .getAllProfileData(this.usuario.id)
                .then(response => {
                    const data = response.data.data

                    if (data) {
                        this.setAllowRegisterBtn(data.Anexos === null)
                        this.setAllowExportBtn(data.PlanejamentoGestao !== null)
                    }
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => {
                    this.setIsLoading(false)
                })
        },
        opportunityPanelBtnClick() {
            if (this.$route.name === 'OpportunityPanel') {
                location.reload()
            }
        },
        connectionsBtnClick() {
            if (this.$route.name === 'ConnectionsPage') {
                location.reload()
            }
        },
        validateStateSidebar(nameField) {
            const { $dirty, $error } = this.$v.sidebarForm[nameField]
            return $dirty ? !$error : null
        },
        validateStateUpdatePwd(nameField) {
            const { $dirty, $error } = this.$v.updatePwdForm[nameField]
            return $dirty ? !$error : null
        },
        onSidebarSubmit(event) {
            this.$v.sidebarForm.$touch()
            if (this.$v.sidebarForm.$anyError) {
                return null
            }
            const data = {
                ...this.management,
                nome: this.sidebarForm.nome,
                email: this.sidebarForm.email
            }
            this.setIsLoading(true)
            const request = platformApi.sendInvite(data)

            request
                .then(response => {
                    this.message = response.data.message
                    this.errorModal = false
                    this.showModal('warning-modal-ref')
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => {
                    this.setIsLoading(false)
                    this.showModal('warning-modal-ref')
                })
        },
        openSidebar() {
            this.$v.sidebarForm.$reset()
            this.sidebarForm.nome = null
            this.sidebarForm.email = null
        },
        showModal(refModalName) {
            this.$refs[refModalName].show()
        },
        hideModal(refModalName) {
            this.$refs[refModalName].hide()
        },
        logout() {
            this.setIsLoading(true)

            authenticationApi
                .logout()
                .then(response => {
                    localStorage.clear()
                    this.$router.push('/')
                    this.changeIsLogged(false)
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => {
                    this.setIsLoading(false)
                })
        },
        openSidebarUpdatePwd() {
            this.$v.updatePwdForm.$reset()
            this.showPassword = false
            this.showConfirmPassword = false
            this.showCurrentPassword = false
            this.updatePwdForm.password = null
            this.updatePwdForm.confirmPassword = null
            this.updatePwdForm.currentPassword = null
        },
        updatePwdSubmit(event) {
            this.$v.updatePwdForm.$touch()

            if (this.$v.updatePwdForm.$anyError) {
                return null
            }

            this.setIsLoading(true)

            const data = {
                password_atual: this.updatePwdForm.currentPassword,
                password: this.updatePwdForm.password,
                password_confirmation: this.updatePwdForm.confirmPassword
            }

            authenticationApi
                .changePassword(data)
                .then(response => {
                    this.message = 'Senha alterada com sucesso!'
                    this.closeSidebarUpdatePwd()
                    this.showModal('success-modal-ref')
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => {
                    this.setIsLoading(false)
                })
        },
        closeSidebarUpdatePwd() {
            this.$root.$emit('bv::toggle::collapse', 'sidebar-update-pwd')
        }
    },
    created() {
        this.fetch()
    }
}
</script>

<style scope src="./DashboardGridPage-light-theme.css"></style>
<style scope src="./DashboardGridPage-dark-theme.css"></style>



// WEBPACK FOOTER //
// src/pages/private/dashboard-page/DashboardGridPage.vue